import * as Permission from '../common/util/Permission';

export const VIEW_MODE_PARTNER1 = 'partner1';
export const VIEW_MODE_PARTNER2 = 'partner2';
export const VIEW_MODE_DEVELOPER = 'developer';

/* this object can be used only in browser - in server we need multiple users */
let globalPermissionObject;

export function hasPermission(perm) {
    let permissionObject = globalPermissionObject;

    return Permission.hasPermissionInternal(perm, permissionObject);
}

export function hasOrganisationPermission(perm, organisationId) {
    let permissionObject = globalPermissionObject;

    return Permission.hasOrganisationPermissionInternal(perm, organisationId, permissionObject);
}


/**
 *
 * @param permissionObject
 */
export function setPermissionObject(permissionObject) {
    globalPermissionObject = permissionObject;
}

/**
 *
 * @returns permissionObject
 */
export function getPermissionObject() {
    return globalPermissionObject;
}

let developerMode = true;

/* read developer mode from local storage */
if (typeof window === 'object' && 'localStorage' in window) {
    if (window.localStorage.getItem('developerMode') !== undefined) {
        developerMode = window.localStorage.getItem('developerMode') === "true" ? true : false;
    }
}

export function toggleDeveloperMode() {
    developerMode = !developerMode;
    if (typeof window === 'object' && 'localStorage' in window) {
        window.localStorage.setItem('developerMode', developerMode);
    }
    return developerMode;
}

export function toggleViewMode(type) {
    if (typeof window === 'object' && 'localStorage' in window) {
        if (type === VIEW_MODE_PARTNER1 || type === VIEW_MODE_PARTNER2 || type === VIEW_MODE_DEVELOPER) {
            window.localStorage.setItem('viewMode', type);
            console.log('viewMode', type);
        } else {
            window.localStorage.removeItem('viewMode');
        }
        window.localStorage.removeItem('developerMode');
    }
}

export function getViewMode() {
    if (typeof window === 'object' && 'localStorage' in window) {
        return window.localStorage.getItem('viewMode');
    }
    return null;
}

export function getDeveloperMode() {
    return developerMode || getViewMode() === VIEW_MODE_DEVELOPER;
}

export function developerModeEnabled(organisationId) {
    if (getDeveloperMode() || getViewMode() === VIEW_MODE_DEVELOPER) {
        if (organisationId && hasOrganisationPermission(Permission.PERM_DEVELOPER, organisationId)) {
            return true;
        } else if (hasPermission(Permission.PERM_DEVELOPER)) {
            return true;
        }
    }
    return false;
}


export function isDeveloper(orgId) {
    return hasPermission(Permission.PERM_DEVELOPER) && (developerModeEnabled(orgId));
}
export function isPartner2(orgId) {
    return hasPermission(Permission.PERM_PARTNER2) || isDeveloper(orgId) || getViewMode() === VIEW_MODE_PARTNER2;
}
export function isPartner1(orgId) {
    return hasPermission(Permission.PERM_PARTNER1) || isDeveloper(orgId) || isPartner2(orgId) || getViewMode() === VIEW_MODE_PARTNER1;
}
